import { Dictionary } from '@/src/lib/dictionary/types';

export function getRegionLabelForSelectedCountry(country: string, dict: Dictionary) {
  if (['PL', 'NZ'].includes(country)) {
    return dict.userProfile.userData.region;
  }

  return dict.userProfile.userData.state;
}
